<template>
  <div>
    <!-- Page title -->
    <page-title icon="fas fa-file-invoice-dollar " main="PPR" sub="Plano Venda Direta">
      <base-button
        slot="actions"
        @click="modal0 = true"
        type="info"
        class="ml-3"
        size="sm"
        v-if="this.$can('index', 'user')"
        >Cadastrar</base-button
      >
    </page-title>
    <div class="card mt-2" style="padding: 0rem 1rem">
      <div class="row">
          <div  class="col-lg-12 card-header">
            <h5 class="h3 mb-0">Plano Venda Direta</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1"> Configure quais dados deverão ser listados:  </h6>
          </div>
        <div class="col-md-3 mt-3">
          <label class="form-control-label">Cargo</label>
          <multiselect
            v-model="filter.category"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :options="cargo"
            placeholder="Selecionar Cargo"
          ></multiselect>
        </div>
        <div class="col-md-3 mt-3">
          <label class="form-control-label">Periodo</label>
          <multiselect
            v-model="partSearch"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :options="participation"
            label="descricao"
            placeholder="Selecionar Período"
          ></multiselect>
        </div>
        <div class="col-md-3 mt-5">
          <base-button icon type="info" @click="search">
            <span class="btn-inner--icon">
              <i class="fas fa-search"></i>
            </span>
            <span class="btn-inner--text"><strong>Pesquisar
              </strong></span>
          </base-button>
          <base-button
            type="secondary"
            class="mr-2"
            @click="clearFilters">
            Limpar Filtros
          </base-button>
        </div>
      </div>
      <modal :show.sync="modal0">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Cadastrar Plano Venda Direta
          </h5>
        </template>
        <form role="form" @submit.prevent="save">
          <div class="row justify-content-md-center">
            <div class="col-6 form-group">
              <label class="form-control-label">Cargo</label><br />
              <multiselect
                v-model="cargoSelected"
                :options="cargo"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Cargo"
              ></multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label"
                >Percentual de Participação</label
              ><br />
              <input
                type="number"
                class="form-control"
                placeholder="Selecionar Percentual"
                v-model="percentual"
                aria-label="Selecionar Percentual"
              />
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Período</label>
              <multiselect
                v-model="partSelected"
                :options="participation"
                label="descricao"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Período"
              ></multiselect>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button class="mr-2" type="secondary" @click="modal0 = false"
            >Fechar</base-button
          >
          <base-button type="info" @click="save">Salvar</base-button>
        </template>
      </modal>
      <modal :show.sync="modal1">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Editar Plano Venda Direta
          </h5>
        </template>
        <form role="form" @submit.prevent="editVenda" >
          <div class="row justify-content-md-center mb-3">
            <div class="col-6 form-group">
              <label class="form-control-label">Cargo</label><br />
              <multiselect
                v-model="venda.human_category"
                :options="cargo"
                :disabled="true"
                placeholder="Selecionar Cargo"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label"
                >Percentual de Participação</label
              ><br />
              <input
                type="number"
                class="form-control"
                placeholder="Selecionar Percentual"
                v-model="venda.percentage_partipation"
              />
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Período</label>
              <multiselect
                v-model="venda.period"
                :options="participation"
                :disabled="true"
                placeholder="Selecionar Período"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="modal1 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editVenda">Atualizar</base-button>
        </template>
      </modal>
      <div class="tableStyle">
        <el-table
          v-loading= "isLoading"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :data="saleDirect"
          min-wid_typeth="500px"
        >
          <el-table-column
            label="Cargo"
            prop="is_coordinator"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ row.human_category }}
          </el-table-column>

          <el-table-column
            label="Percentual de participação"
            prop="percentage_partipation"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ row.percentage_partipation.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} %
          </el-table-column>

          <el-table-column
            label="Período"
            prop="period"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ row.period }}
          </el-table-column>

          <el-table-column label="Ações" min-width="100" v-slot="{ row }">
            <div class="row">
              <el-dropdown
                trigger="hover"
                class="dropdown"
                style="cursor: pointer"
              >
                <span class="btn btn-sm btn-icon-only text-success">
                  <i class="fas fa-ellipsis-v mt-2"></i>
                </span>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <a class="dropdown-item" href="#" @click="edit(row)" >
                    Editar</a
                  >
                  <a class="dropdown-item" href="#" @click="remove(row)">
                    Excluir</a
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Modal from "@/components/Modal";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "app",
  components: {
    PageTitle,
    Modal,
    Multiselect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      filter: {
        category: null,
      },
      modal0: false,
      modal1: false,
      cargoSelected: null,
      cargo: ["Vendedor", "Gerente Comercial"],
      participation: [],
      partSelected: "",
      percentualEdit: null,
      cargoSearch: "",
      partSearch: "",
      isLoading: false,
      venda: {},
      gerente: null,
      percentual: null,
      checkbox: null,
      saleDirect: [],
    };
  },
  mounted() {
    this.getParticipation();
    this.getSaleDirect();
  },
  methods: {
    getSaleDirect() {
      this.isLoading = true;
      this.$http.secured
        .get(`/api/v1/sale_direct`, {})
        .then((response) => {
          this.saleDirect = response.data;
          this.isLoading = false;

        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search() {
      let category;
      if (this.filter.category == "Gerente Comercial") {
        category = "manager";
      } else if (this.filter.category == "Coordenador") {
        category = "coordinator";
      } else if (this.filter.category == "Vendedor") {
        category = "salesman";
      }
      this.$http.secured
        .get("/api/v1/sale_direct", {
          params: {
            "sale_direct[category]": category ? category : null,
            "sale_direct[period]": this.partSearch
              ? this.partSearch.descricao
              : null,
          },
        })
        .then((response) => {
          this.saleDirect = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    save() {
      if (this.cargoSelected == "Gerente Comercial") {
        this.cargoSelected = 0;
      } else if (this.cargoSelected == "Coordenador") {
        this.cargoSelected = 1;
      } else if (this.cargoSelected == "Vendedor") {
        this.cargoSelected = 2;
      }
      if (
        this.percentual != null &&
        this.cargoSelected != null &&
        this.partSelected != ""
      ) {
        this.$http.secured
          .post(`/api/v1/sale_direct`, {
            percentage_partipation: this.percentual,
            period: this.partSelected.descricao,
            category: this.cargoSelected,
          })
          .then((response) => {
            this.getSaleDirect();
            this.limpCampos();
          })
          .catch((error) => this.setError(error, "Something went wrong"));
        this.modal0 = false;
      }
    },
    limpCampos() {
      this.cargoSelected = null;
      this.percentual = null;
      this.partSelected = "";
    },
    edit(venda) {
      this.venda = venda;
      this.modal1 = true;
    },
    editVenda() {
      this.$http.secured
        .put(`/api/v1/sale_direct/${this.venda.id}`, this.venda)
        .then((response) => {
          this.getSaleDirect();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
      this.modal1 = false;
    },
    remove(venda) {
      if (
        confirm(
          "Deseja excluir a Venda Direta " + `${venda.human_category}` + "?"
        )
      ) {
        this.$http.secured
          .delete(`/api/v1/sale_direct/${venda.id}`, venda)
          .then((response) => {
            this.getSaleDirect();
          })
          .catch((error) => this.setError(error, "Cannot delete venda direta"));
      }
    },
    getParticipation() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
        .then((response) => {
          this.participation = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    clearFilters() {
      this.filter.category = null,
      this.partSearch = ""
    },
  },
  computed: {},
};
</script>

<style>
.tableStyle {
  margin-top: 3%;
}
.title {
  margin-bottom: 2%;
}
.el-table__row {
  background-color: white;
  text-align: center;
}
.checkboxtext {
  font-size: 100px;
  display: inline;
  zoom: 1.5;
  margin-top: 2;
}
.labelCheck {
  margin-left: 5px;
}
</style>
